import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../../mock";

export default function CtaBanner() {
  return (
    <section className="bg-cream py-24">
      <div className="max-w-[1300px] mx-auto px-6">
        <div className="relative rounded-sm overflow-hidden">
          <img src={IMAGES.heroAlt} alt="Book your visit" className="w-full h-[420px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-charcoal/90 to-charcoal/40" />
          <div className="absolute inset-0 flex items-center">
            <div className="px-8 md:px-16 max-w-xl">
              <span className="eyebrow text-gold">Begin Your Journey</span>
              <h2 className="font-display text-4xl lg:text-5xl font-light text-cream leading-tight mt-4">
                Your complimentary consultation awaits
              </h2>
              <p className="font-sans text-cream/75 mt-5 leading-relaxed">
                Meet with our team to design a treatment plan tailored entirely to you — no pressure, simply expert guidance.
              </p>
              <Link to="/contact" className="inline-block btn-gold mt-8">Book Now</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
